import { atom } from 'recoil';
import axios from '../utils/axios';
// eslint-disable-next-line import/extensions
import localStorageEffect from './localStorageEffect.js';
import { Device } from '../@types/model/device';

const deviceState = atom<Device[]>({
  key: 'device',
  default: [],
  effects: [localStorageEffect('device')]
});

const getDevices = async (size = 25) => {
  let devices: Device[] = (await axios.get('/api/v2/device?size=' + size)).data.data.map(
    (dat: any) => {
      return dat;
    }
  );
  return devices;
};

export { deviceState, getDevices };
